import { Moon, Sun } from "lucide-react";

import { useTheme } from "@/components/providers/theme-provider";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { SidebarTrigger } from "@/components/ui/sidebar";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { usePreferences } from "@/components/providers/preferences-provider";
import { cn } from "@/lib/utils";

import { HeaderBreadcrumbs } from "./breadcrumbs";
import { CommandMenu } from "./command-menu";
import { LayoutControls } from "./layout-controls";
import { Notifications } from "./notifications";
import { OrderSoundToggle } from "./order-sound-toggle";

function ThemeToggle() {
  const { resolvedTheme, setTheme } = useTheme();
  return (
    <Button
      variant="ghost"
      size="icon"
      aria-label="Toggle dark mode"
      onClick={() => setTheme(resolvedTheme === "dark" ? "light" : "dark")}
    >
      <Sun className="hidden dark:block" />
      <Moon className="dark:hidden" />
    </Button>
  );
}

export function SiteHeader() {
  const { preferences } = usePreferences();
  return (
    <header
      className={cn(
        "flex h-14 shrink-0 items-center gap-2 border-b transition-[width,height] ease-linear",
        preferences.navbarStyle === "sticky" &&
          "bg-background/80 supports-backdrop-filter:bg-background/65 sticky top-0 z-30 rounded-t-[inherit] backdrop-blur-md",
      )}
    >
      <div className="flex w-full items-center gap-2 px-3 lg:px-5">
        <Tooltip>
          <TooltipTrigger render={<SidebarTrigger className="-ml-1" />} />
          <TooltipContent side="bottom">
            Toggle sidebar <span className="text-muted-foreground ml-1">⌘B</span>
          </TooltipContent>
        </Tooltip>
        <Separator
          orientation="vertical"
          className="mx-1 data-[orientation=vertical]:h-4 data-[orientation=vertical]:self-center"
        />
        <div className="hidden min-w-0 md:block">
          <HeaderBreadcrumbs />
        </div>
        <div className="ml-auto flex min-w-0 flex-1 items-center justify-end gap-1 md:flex-none">
          <div className="min-w-0 flex-1 md:flex-none">
            <CommandMenu />
          </div>
          <OrderSoundToggle />
          <Notifications />
          <LayoutControls />
          <ThemeToggle />
        </div>
      </div>
    </header>
  );
}
